import { createContext, useCallback, useEffect, useState } from "react";
import ShopService from "../services/ShopService";
import { STORAGE_KEYS } from "../const";
import * as TerminalHelper from "helpers/TermialHelper";
import ShopsHelper from "../helpers/ShopsHelper";

const ShopContext = createContext();

export function ShopProvider(props) {
  const [shopId, setShopId] = useState(null);
  const [selectedShop, setSelectedShop] = useState(null);

  const cachedPaymentModesString = localStorage.getItem(STORAGE_KEYS.PAYMENT_MODES);
  const cachedPaymentModes = cachedPaymentModesString !== null ? JSON.parse(cachedPaymentModesString) : [];
  const [paymentModes, setPaymentModes] = useState(cachedPaymentModes);

  const hasFullKotValidity = ShopsHelper.hasFullKotValidity(selectedShop);
  const hasKotLiteValidity = ShopsHelper.hasKotLiteValidity(selectedShop);
  const hasKotValidity = ShopsHelper.hasKotValidity(selectedShop);
  const hasLabelScaleValidity = ShopsHelper.hasLabelScaleValidity(selectedShop);

  const getShopProfile = useCallback(async () => {
    const profile = await ShopService.loadShopProfile(true);
    if (profile) {
      setSelectedShop(profile);
      setShopId(profile.id);
    }
    return profile;
  }, []);

  const fetchPaymentModes = useCallback(
    async (forceRefresh = false) => {
      try {
        if (paymentModes.length > 0 && !forceRefresh) return;

        const resp = await ShopService.getPaymentModes();
        setPaymentModes(resp);
      } catch (error) {
        console.error("Error loading payment modes:", error);
      }
    },
    [paymentModes.length],
  );

  useEffect(() => {
    if (shopId) {
      fetchPaymentModes();
    }
  }, [shopId, fetchPaymentModes]);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEYS.TAX_PREFERENCE, selectedShop?.tax_preference);
    localStorage.setItem(STORAGE_KEYS.TAX_REGION, selectedShop?.tax_region);

    // Default stock option
    const terminalSettings = TerminalHelper.getTerminalSettings();
    if (!terminalSettings.preventNegativeStock) {
      TerminalHelper.saveTerminalSettings({
        ...terminalSettings,
        preventNegativeStock: "allow_negative_stock",
      });
    }
    //eslint-disable-next-line
  }, [shopId, selectedShop]);

  useEffect(() => {
    getShopProfile();
  }, [getShopProfile]);

  return (
    <ShopContext.Provider
      value={{
        selectedShop,
        shopId,
        setSelectedShop,
        setShopId,
        paymentModes,
        fetchPaymentModes,
        hasFullKotValidity,
        hasKotLiteValidity,
        hasKotValidity,
        hasLabelScaleValidity,
      }}
    >
      {props.children}
    </ShopContext.Provider>
  );
}

export default ShopContext;
